export default __webpack_public_path__ + "static/traefik-proxy-logo--white-82153be41e0ce620a921b4bce974f6d8.svg";